import React from "react";
import PropTypes from "prop-types";
import ToggleSwitch from "@client.components/ToggleSwitch";
import { useSelector } from "react-redux";
import { makeNotificationSettings } from "@client.pages/Settings/reducer";
import Loader from "@client.components/Loader";

const SettingsSwitch = ({ onSave, notificationType }) => {
  const notificationSettings = useSelector(makeNotificationSettings);

  if (notificationSettings.load || notificationSettings.data.length === 0) {
    return <Loader loading={true} />;
  }

  const notification = notificationSettings.data.find(
    (n) => n.type === notificationType
  );

  return (
    <ToggleSwitch
      value={notification.isEnabled}
      onChange={(v) => onSave({ ...notification, isEnabled: v })}
    />
  );
};

SettingsSwitch.propTypes = {
  notificationType: PropTypes.number,
  onSave: PropTypes.func,
};

export default SettingsSwitch;
